export default "__VITE_ASSET__BhGDlV9V__"